import {
  AppBar,
  HHBreadcrumbs,
  HHLink,
  HHTypography,
} from '@hinge-health/react-component-library';
import { matchPath, useLocation } from 'react-router-dom';
import { routes } from '../constants/strings/routes';

export const ACCOUNTING_BREADCRUMBS_TEST_ID = 'accounting-breadcrumbs-app-bar';

const breadcrumbPathPatterns = [
  {
    path: routes.accounting.home,
    text: 'Home',
  },
  {
    path: `${routes.accounting.home}${routes.accounting.subscriptionEstimates}`,
    text: 'Subscription Revenue Recognition',
  },
  {
    path: `${routes.accounting.home}${routes.accounting.csvUpload}`,
    text: 'CSV Upload',
  },
];

const BreadCrumb = (): JSX.Element | null => {
  const location = useLocation();

  const match = breadcrumbPathPatterns.find(p =>
    matchPath(p.path, location.pathname),
  );

  if (!match) {
    return null;
  }

  return (
    <HHBreadcrumbs
      aria-label="breadcrumb"
      sx={{ display: 'flex', alignItems: 'center', minHeight: 40 }}
    >
      <HHLink color="inherit" href={routes.accounting.home} underline="hover">
        Operations Hub
      </HHLink>
      <HHLink color="inherit" href={routes.accounting.home} underline="hover">
        Accounting
      </HHLink>
      <HHTypography color="text.primary" hhVariant="variant-bypass">
        {match.text}
      </HHTypography>
    </HHBreadcrumbs>
  );
};

const AccountingBreadcrumbs = (): JSX.Element => (
  <AppBar
    elevation={3}
    variant="elevation"
    color="inherit"
    position="sticky"
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      padding: 2,
      gap: 2,
    }}
    data-testid={ACCOUNTING_BREADCRUMBS_TEST_ID}
  >
    <BreadCrumb />
  </AppBar>
);

export default AccountingBreadcrumbs;
